import script from "./CollapsibleSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollapsibleSection.vue?vue&type=script&setup=true&lang=ts"

import "./CollapsibleSection.vue?vue&type=style&index=0&id=77063816&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77063816"]])

export default __exports__